/* eslint-disable no-use-before-define */
import { MemoryStorage } from './memoryStorageClass';
import { engine$, Storage } from './Storage';

export const localStorage = new Storage(
    engine$(
        () => window.localStorage,
        /* istanbul ignore next */
        () => new MemoryStorage(),
    ),
);
